import { render, staticRenderFns } from "./MarkAsSeenButtonView.vue?vue&type=template&id=60239a8e&scoped=true"
import script from "./MarkAsSeenButtonView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkAsSeenButtonView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MarkAsSeenButtonView.vue?vue&type=style&index=0&id=60239a8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60239a8e",
  null
  
)

export default component.exports